import { createFileRoute } from "@tanstack/react-router";

import { HubIndexPage, hubQuery } from "@/components/hubs/HubIndexPage";
import { hubIndexHead } from "@/lib/hub-seo";

const PATH = "/bars";

export const Route = createFileRoute("/bars/")({
  loader: ({ context }) => context.queryClient.ensureQueryData(hubQuery("bars")),
  head: ({ loaderData }) =>
    hubIndexHead({
      path: PATH,
      locale: "en",
      loaderData,
      fallbackTitle: 'Bars in Finland — cocktails and wine | what Finland',
      fallbackDescription: 'Finnish bars, wine bars and cocktail rooms by region and price range.',
      listName: 'Bars in Finland',
    }),
  component: () => <HubIndexPage slug="bars" locale="en" />,
});
